Vendd.Scripts.load(function () {
 
    if ($('.x-off-canvas-menu').length <= 0)
        return;

    $(window).resize(function () {
        attachToCanvasMenu();
    });

    var isMoved = false;

    if ($(window).outerWidth() <= 1440) {
        $('.js-main-menu').detach().prependTo('.js-canvas-menu').show();
        isMoved = true;
    }

    function attachToCanvasMenu() {

        if ($(window).outerWidth() <= 1440) {
            if (!isMoved) {
                $('.js-main-menu').detach().prependTo('.js-canvas-menu').show();
                isMoved = true;
            }
        } else {
            if (isMoved) {
                $('.js-main-menu').detach().appendTo('.header-template-one .center-column');
                isMoved = false;

                $("html").removeClass("show-canvas");
                $('.site-overlay').hide();
            }
        }
    }

});
